export default __webpack_public_path__ + "sql-wasm-020d507b33b3853457475156f5e948d9.wasm";